import React, { useState, useEffect } from 'react';
import '../styles/site-gate.css';

const SITE_KEY = 'adeeb-site-access';

export function isSiteUnlocked() {
  return false;
}

export default function SiteGate({ children }) {
  const [unlocked, setUnlocked] = useState(isSiteUnlocked());
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => { fetch('/api/gate', { credentials: 'same-origin' }).then(r => r.json()).then(data => setUnlocked(!!data.unlocked)).catch(() => setError('Could not check site access. Please retry.')); }, []);

  // Let OAuth callback through so the token can be captured
  if (['/auth/callback', '/newsletter/unsubscribe'].includes(window.location.pathname)) return children;

  if (unlocked) return children;

  const handleSubmit = async (e) => {
    e.preventDefault();
    let allowed = false;
    try { const r = await fetch('/api/gate', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ username, password }) }); allowed = r.ok; } catch {}
    if (allowed) {
      localStorage.setItem(SITE_KEY, 'granted');
      setUnlocked(true);
    } else {
      setError('Invalid credentials');
    }
  };

  return (
    <div className="gate-wrapper">
      <form className="gate-box" onSubmit={handleSubmit}>
        <img src="/branding/deenlit-logo.png" alt="Deenlit" className="gate-logo" />
        <p className="gate-subtitle">This site is access-restricted.</p>

        {error && <div className="gate-error">{error}</div>}

        <input
          className="gate-input"
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
        />
        <input
          className="gate-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="gate-btn" type="submit">Enter</button>
      </form>
    </div>
  );
}
